'use client';

export default function ContactUsPage() {
    const primaryColor = '#33bdbf';
    const whiteColor = '#ffffff';
    const lightGray = '#f8f9fa';
    const darkGray = '#333333';

    const containerStyle = {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '40px 20px',
        fontFamily: 'Montserrat, Roboto, sans-serif',
        backgroundColor: whiteColor,
        color: darkGray,
        lineHeight: '1.6',
    };

    const headerStyle = {
        backgroundColor: primaryColor,
        color: whiteColor,
        padding: '60px 20px',
        textAlign: 'center',
        marginBottom: '40px',
        borderRadius: '8px',
    };

    const headerTitleStyle = {
        fontSize: '42px',
        fontWeight: '700',
        margin: '0 0 10px 0',
    };

    const headerSubtitleStyle = {
        fontSize: '16px',
        fontWeight: '300',
        opacity: 0.9,
        margin: '0',
    };

    const sectionStyle = {
        marginBottom: '40px',
        paddingBottom: '30px',
        borderBottom: `1px solid #e0e0e0`,
    };

    const sectionTitleStyle = {
        fontSize: '24px',
        fontWeight: '600',
        color: primaryColor,
        marginBottom: '15px',
        marginTop: '20px',
    };

    const contactBoxStyle = {
        backgroundColor: lightGray,
        padding: '20px',
        borderRadius: '8px',
        borderLeft: `4px solid ${primaryColor}`,
        marginTop: '20px',
    };

    const contactMethodStyle = {
        marginBottom: '30px',
    };

    const contactLabelStyle = {
        fontWeight: '600',
        color: primaryColor,
        marginBottom: '8px',
        fontSize: '16px',
    };

    const inputStyle = {
        width: '100%',
        padding: '12px',
        marginBottom: '15px',
        border: `1px solid #ddd`,
        borderRadius: '4px',
        fontFamily: 'inherit',
        fontSize: '14px',
        boxSizing: 'border-box',
    };

    const textareaStyle = {
        ...inputStyle,
        minHeight: '150px',
        resize: 'vertical',
    };

    const buttonStyle = {
        backgroundColor: primaryColor,
        color: whiteColor,
        padding: '12px 30px',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const lastSectionStyle = {
        ...sectionStyle,
        borderBottom: 'none',
    };

    const responsiveGridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px',
        marginTop: '20px',
    };

    return (
        <div style={containerStyle}>
            {/* Header */}
            <div style={headerStyle}>
                <h1 style={headerTitleStyle}>Contact Us</h1>
                <p style={headerSubtitleStyle}>We'd love to hear from you. Get in touch with us today!</p>
            </div>

            {/* Introduction */}
            <div style={sectionStyle}>
                <p>
                    Have a question, suggestion, or need support? The fitfind team is here to help. Whether you're experiencing
                    an issue, have feedback, or just want to say hello, feel free to reach out to us using any of the methods
                    below. We aim to respond to all inquiries within 24-48 hours.
                </p>
            </div>

            {/* Contact Methods */}
            <div style={sectionStyle}>
                <h2 style={sectionTitleStyle}>Get In Touch</h2>
                <div style={responsiveGridStyle}>
                    <div style={contactBoxStyle}>
                        <div style={contactLabelStyle}> Email</div>
                        <p style={{ margin: '10px 0 0 0' }}>
                            <a href="mailto:support@fitfind.com" style={{ color: primaryColor, textDecoration: 'none' }}>
                                support@fitfind.com
                            </a>
                        </p>
                        <p style={{ fontSize: '13px', color: '#666', margin: '5px 0 0 0' }}>General inquiries and support</p>
                    </div>

                    <div style={contactBoxStyle}>
                        <div style={contactLabelStyle}> Business</div>
                        <p style={{ margin: '10px 0 0 0' }}>
                            <a href="mailto:business@fitfind.com" style={{ color: primaryColor, textDecoration: 'none' }}>
                                business@fitfind.com
                            </a>
                        </p>
                        <p style={{ fontSize: '13px', color: '#666', margin: '5px 0 0 0' }}>Partnerships and collaborations</p>
                    </div>

                    <div style={contactBoxStyle}>
                        <div style={contactLabelStyle}> Bug Report</div>
                        <p style={{ margin: '10px 0 0 0' }}>
                            <a href="mailto:bugs@fitfind.com" style={{ color: primaryColor, textDecoration: 'none' }}>
                                bugs@fitfind.com
                            </a>
                        </p>
                        <p style={{ fontSize: '13px', color: '#666', margin: '5px 0 0 0' }}>Report issues or technical problems</p>
                    </div>
                </div>
            </div>

            {/* Contact Form */}
            <div style={sectionStyle}>
                <h2 style={sectionTitleStyle}>Send Us a Message</h2>
                <form
                    style={{
                        marginTop: '20px',
                    }}
                >
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Name *</label>
                        <input type="text" placeholder="Your name" style={inputStyle} required />
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Email *</label>
                        <input type="email" placeholder="Your email address" style={inputStyle} required />
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Subject *</label>
                        <input type="text" placeholder="What is this about?" style={inputStyle} required />
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Message *</label>
                        <textarea placeholder="Tell us more about your inquiry..." style={textareaStyle} required></textarea>
                    </div>

                    <button
                        type="submit"
                        style={buttonStyle}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#2a9a9d')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = primaryColor)}
                    >
                        Send Message
                    </button>
                </form>
            </div>

            {/* Office Information */}
            <div style={sectionStyle}>
                <h2 style={sectionTitleStyle}>Our Location</h2>
                <div style={contactBoxStyle}>
                    <p style={{ marginTop: 0 }}>
                        <strong>Mailing Address:</strong>
                    </p>
                    <p>
                        fitfind
                        <br />
                        123 Main Street
                        <br />
                        City, State 12345
                        <br />
                        Country
                    </p>
                    <p>
                        <strong>Phone:</strong> +1 (555) 123-4567
                    </p>
                    <p style={{ marginBottom: 0 }}>
                        <strong>Business Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM (EST)
                    </p>
                </div>
            </div>

            {/* Social Media */}
            <div style={lastSectionStyle}>
                <h2 style={sectionTitleStyle}>Follow Us</h2>
                <p>Connect with us on social media for updates, news, and community engagement:</p>
                <div style={{ marginTop: '20px' }}>
                    <a
                        href="#"
                        style={{
                            display: 'inline-block',
                            marginRight: '15px',
                            color: primaryColor,
                            textDecoration: 'none',
                            fontWeight: '600',
                        }}
                    >
                        Twitter
                    </a>
                    <a
                        href="#"
                        style={{
                            display: 'inline-block',
                            marginRight: '15px',
                            color: primaryColor,
                            textDecoration: 'none',
                            fontWeight: '600',
                        }}
                    >
                        Facebook
                    </a>
                    <a
                        href="#"
                        style={{
                            display: 'inline-block',
                            marginRight: '15px',
                            color: primaryColor,
                            textDecoration: 'none',
                            fontWeight: '600',
                        }}
                    >
                        Instagram
                    </a>
                    <a
                        href="#"
                        style={{
                            display: 'inline-block',
                            color: primaryColor,
                            textDecoration: 'none',
                            fontWeight: '600',
                        }}
                    >
                        LinkedIn
                    </a>
                </div>
            </div>

            {/* Footer */}
            <div
                style={{
                    backgroundColor: primaryColor,
                    color: whiteColor,
                    padding: '20px',
                    textAlign: 'center',
                    marginTop: '60px',
                    borderRadius: '8px',
                    fontSize: '14px',
                }}
            >
                <p style={{ margin: 0 }}>© {new Date().getFullYear()} fitfind. All rights reserved.</p>
            </div>
        </div>
    );
}
